import { render, staticRenderFns } from "./ListRegisterRequests.vue?vue&type=template&id=c1bd45ba&scoped=true&"
import script from "./ListRegisterRequests.vue?vue&type=script&lang=js&"
export * from "./ListRegisterRequests.vue?vue&type=script&lang=js&"
import style0 from "./ListRegisterRequests.vue?vue&type=style&index=0&id=c1bd45ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bd45ba",
  null
  
)

export default component.exports